"use strict";

var React = require("react");

var SvgIconAddPlusV1 = function SvgIconAddPlusV1() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 12 12",
    },
    /*#__PURE__*/ React.createElement(
      "g",
      {
        fill: "none",
        fillRule: "evenodd",
      },
      /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M11.833 6.833h-5v5H5.167v-5h-5V5.167h5v-5h1.666v5h5z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d: "M-4-4h20v20H-4z",
      })
    )
  );
};

exports["foreignIcon"] = SvgIconAddPlusV1;
